<template>
  <div class="flex flex-col w-full gap-20">
    <div
      class="flex flex-col md:flex-row md:h-[306px] w-full bg-surface-default-hi rounded-lg"
    >
      <div class="flex grow flex-col h-full items-center justify-center p-24">
        <div class="text-static-default-mid heading-2 mt-32">
          {{ i18n(translations.somethingWentWrong) }}
        </div>
        <div class="text-static-default-low body-2 mt-8">
          {{ i18n(translations.maybeThereIsAProblemWithYourConnection) }}
        </div>

        <RevButton
          class="mt-32"
          data-test="retry-button"
          size="small"
          variant="secondary"
          @click="emit('retry')"
        >
          {{ i18n(translations.tryAgain) }}
        </RevButton>
      </div>

      <picture>
        <RevIllustrationSource
          :height="306"
          media="(min-width: 768px)"
          src="/img/cms/PersonalizedFeed-error-desktop.png"
          :width="478"
        />

        <RevIllustration
          alt=""
          class="max-md:rounded-b-lg md:rounded-r-lg max-md:w-full object-cover"
          :height="220"
          sizes="(min-width: 768px) 100vw, 478px"
          src="/img/cms/PersonalizedFeed-error-mobile.png"
          :width="768"
        />
      </picture>
    </div>
    <div class="hidden md:flex justify-end gap-12">
      <RevButtonIcon
        :disabled="true"
        :icon="IconChevronLeft"
        variant="primary"
      />
      <RevButtonIcon
        :disabled="true"
        :icon="IconChevronRight"
        variant="primary"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { RevIllustration } from '@ds/components/Illustration'
import { RevIllustrationSource } from '@ds/components/IllustrationSource'
import { IconChevronLeft } from '@ds/icons/IconChevronLeft'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import translations from './ErrorState.translations'

const i18n = useI18n()
const emit = defineEmits<{
  (e: 'retry'): void
}>()
</script>
